module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/confirm-modal/confirm-modal.component.scss
// module id = ./src/app/modules/common-module/components/confirm-modal/confirm-modal.component.scss
// module chunks = 9